'use strict';

(function (angular) {
  angular.module('ibf').controller('loginCtrl', ['$scope', 'alertify', '$window', 'commonSrv', 'sessionSrv', '$state', '$stateParams', loginCtrl]);

  function loginCtrl($scope, alertify, $window, commonSrv, sessionSrv, $state, $stateParams) {
    var url = document.URL;
    var log = this,
        common = commonSrv,
        session = sessionSrv;
    log.version = common.version_app;
    log.isLoading = false;
    log.isMobile = false;

    function init() {
      if (url.indexOf('ibuyflowers.com') !== -1 || url.indexOf('ibuyflowers.sbx.cloud') !== -1 || url.indexOf('ibuyflowersdev.sbx.cloud') !== -1) {
        window.location.href = common.actual_login_redirect;

        return;
      }

      // console.log('navi', navigator.userAgent);

      if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/IEMobile/i)) {
        log.isMobile = true;
      }

      log.validate = function (form) {
        var check = $(form).find('.ng-invalid').length;
        return check > 0 ? false : true;
      };

      if ($stateParams) {
        log.code = $stateParams.code;
        log.user_id = $stateParams.id;
      }
    }

    log.login = function () {

      log.isLoading = true;
      if (log.validate('.js-form')) {
        var form_data = {
          login: log.email,
          password: log.password,
          domain: common.actual_domain
        };

        session.login(form_data).then(function () {

          if (session.loginStatus) {

            common.setHeaders(session.user.token);
            sessionSrv.setToken(session.user.token);
            var user_id = session.user.data.id;

            var query = common.sbx.with('user').setPage(1).fetchModels(['grower', 'customer', 'manager']).setPageSize(1000).andWhereIsEqual('user_id', user_id).andWhereIsEqual('from_manager', false).compile();

            try {
              common.method.query(common.urls.find, query).then(function () {
                var response = common.response.post_query;
                if (!response.data.results.length) {
                  log.isLoading = false;
                  return alertify.error('The user is invalid, please contact your account admin support@ibuyflower.com');
                }

                var role = response.data.results[0].role ? response.data.results[0].role : null;
                if (!response.data.results[0].active) {
                  log.isLoading = false;
                  return alertify.error('The user is disabled, please contact your account admin support@ibuyflower.com');
                }

                common.setUserData(session.user);

                if (role) {
                  var user = common.getUserData();
                  user.ibf_role = role;
                  user.version_app = common.version_app;

                  common.setConfigTrackJS({
                    userId: user.data.email,
                    sessionId: user.data.id.toString()
                  });

                  common.addTrackJSMetadata('role', role);

                  var ts = Math.round(new Date().getTime() / 1000);

                  user.data.name = response.data.results[0].first_name + ' ' + response.data.results[0].last_name;
                  user.key = response.data.results[0]._KEY;
                  if (role === 'GROWER') {
                    user.grower = response.data.results[0].grower;
                    user.grower_admin = response.data.fetched_results.grower[user.grower].admin;
                    user.grower_name = response.data.fetched_results.grower[user.grower].company_name;
                  }
                  $state.go('validate');
                } else {
                  log.isLoading = false;
                  alertify.error('The user doesn\'t have an specified role, please contact your account admin support@ibuyflower.com');
                }
              });
            } catch (e) {
              log.isLoading = false;
              alertify.error(e);
            }
          } else {
            alertify.error('Incorrect Email or Password, try again.');
            log.isLoading = false;
          }
        });
      } else {
        alertify.error('All fields are required.');
        log.isLoading = false;
      }
    };

    log.retrieve = function () {

      log.isLoading = true;
      var data = {
        user_email: log.email, // user_email or user_id
        domain: common.actual_domain,
        subject: 'iBuyflowers Password Recovery',
        email_template: common.password_mail //email_template or email_body
      };

      common.setForgotHeaders();
      common.method.query(common.urls.password, data).then(function () {

        log.isLoading = false;
        var response = common.response.post_query.data;
        if (response.success) {
          common.confirmModal({
            title: 'Ibuyflowers',
            msj: 'An message has been sent to your email account with the instructions to recover your account.',
            saveText: 'OK',
            hideCancel: true
          }, function () {});
        } else {
          alertify.error(response.error);
        }
      });
    };

    log.change_password = function () {
      log.isLoading = true;
      if (!log.password || !log.conf_password) {
        alertify.error('All fields are required.');
        return false;
      }

      if (log.password != log.conf_password) {
        alertify.error('Both password must match.');
        return false;
      }

      var data = {
        code: log.code,
        user_id: log.user_id,
        domain: common.actual_domain,
        password: log.password
      };

      common.method.put(common.urls.password, data).then(function () {
        log.isLoading = false;
        var response = common.response.put.data;
        if (response.success) {
          alertify.success('Password changed.');
          $state.go('login');
        } else {
          alertify.error(response.error);
        }
      });
    };

    init();
  }
})(angular);
//# sourceMappingURL=loginCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('validateCtrl', ['alertify', '$state', 'sessionSrv', 'environment', 'commonSrv', validateCtrl]);

  function validateCtrl(alertify, $state, sessionSrv, environment /*commonSrv*/) {
    var validate = this;

    function init() {

      var search = '?' + window.location.href.split('?')[1];
      var token = '';

      if (search.length > 0 && search.includes('token')) {
        token = search.replace('?token=', '');
        if (token) {
          localStorage.setItem('token', token);
        }
      } else {
        if (sessionSrv.getToken()) {
          token = sessionSrv.getToken();
        } else {
          token = search.replace('?token=', '');
          localStorage.setItem('token', token);
        }
      }

      if (token) {
        sessionSrv.validateToken().then(function (res) {

          if (res.success) {
            if (localStorage.getItem('user_key')) {
              localStorage.removeItem('user_key');
            }

            var state = sessionSrv.redirectUrl;

            switch (sessionSrv.user.role) {
              case 'BOOKKEEPING':
                if (state && state !== 'login' && state !== 'validate' && state.split('.')[0] === 'country') {
                  $state.go(state);
                } else {
                  $state.go('country.accounting');
                }
                break;
              case 'LOGISTICS_SUPPORT':
                if (state && state !== 'login' && state !== 'validate' && state.split('.')[0] === 'country') {
                  $state.go(state);
                } else {

                  if (sessionSrv.user.permissions) {
                    var permissions = sessionSrv.user.permissions;
                    if (!permissions['login_as'] && permissions['variety']) {
                      window.location.href = environment.v2Url + '#/products/variety';
                    }
                  }

                  $state.go('country');
                }
                break;
              case 'SUPPORT':
                if (state && state !== 'login' && state !== 'validate' && state.split('.')[0] === 'country') {
                  $state.go(state);
                } else {
                  $state.go('country.purchaseorders');
                }

                break;
              case 'ADMIN':
                if (state && state !== 'login' && state !== 'validate' && state.split('.')[0] === 'admin') {
                  $state.go(state);
                } else {
                  $state.go('admin.dashboard.salesmonth');
                }
                break;
              case 'GROWER':
                window.mixpanel.init(environment.mixpanel);
                window.mixpanel.identify(sessionSrv.user.id.toString());

                var people = {
                  $email: sessionSrv.user.email,
                  $name: sessionSrv.user.name,
                  role: sessionSrv.user.role
                };
                window.mixpanel.people.set(people);
                if (state && state !== 'login' && state !== 'validate' && state.split('.')[0] === 'grower') {

                  $state.go(state);
                } else {
                  $state.go('grower.orders.list');

                  //  const query = commonSrv.sbx.with('grower_user_config')
                  // .andWhereIsEqual('user', sessionSrv.user.key)
                  // .compile();

                  // commonSrv.method.query(commonSrv.urls.find, query).then((resp) => {
                  // const permissions = (resp && resp.data && Array.isArray(resp.data.results) && resp.data.results[0]) || {};


                  // if (permissions.orders) {
                  //   $state.go('grower.orders.list');
                  // } else if (permissions.claims) {
                  //   $state.go('grower.claims.pending.list');
                  // } else if (permissions.inventory) {
                  //   $state.go('grower.inventory.update_assistant');
                  // } else {
                  //   $state.go(state);
                  // }
                  // }).catch(() => {
                  //   $state.go(state);
                  //   console.log("Error loading grower permissions.");
                  // });
                }
                break;
              case 'COUNTRY_MANAGER':
                if (state && state !== 'login' && state !== 'validate' && state.split('.')[0] === 'country') {
                  $state.go(state);
                } else {
                  $state.go('country.purchaseorders');
                }
                break;
              case 'MANAGER':
                window.location.href = '/admin/#/settings/create_voucher';
                break;
              default:
                sessionSrv.logout();
            }
          } else {
            alertify.error(res.error);
            sessionSrv.logout();
          }
        });
      } else {
        sessionSrv.logout();
      }
    }

    init();
  }
})(angular);
//# sourceMappingURL=validateCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('confirmModalCtrl', ['alertify', 'commonSrv', '$uibModalInstance', '$sce', 'config', confirmModalCtrl]);

  function confirmModalCtrl(alertify, commonSrv, $uibModalInstance, $sce, config) {
    var obj = this,
        common = commonSrv;

    function init() {

      console.log('config', config);
      obj.issue = 0;
      obj.showIssue = config.showIssue || false;
      obj.showRestoreInventory = config.showRestoreInventory || false;
      obj.restoreInventory = config.restoreInventory;
      obj.msjClass = config.msjClass || 'h5';
      obj.title = config.title;
      obj.msj = config.trustMsj ? $sce.trustAsHtml(config.msj || '') : config.msj || '';
      obj.saveText = config.save || 'Yes';
      obj.cancelText = config.cancel || 'No';
      obj.alignRight = !config.alignRight ? 'text-center' : '';
      obj.hideCancelBtn = config.hideCancel || false;

      obj.saveBtnColor = config.saveBtnColor || 'btn-primary';
      obj.cancelBtnColor = config.cancelBtnColor || 'btn-danger';
    }

    obj.onRestoreInventoryChange = function () {
      if (obj.restoreInventory) {
        return;
      }

      common.confirmModal({
        title: 'Warning',
        msj: 'Are you sure you do not want to restore the inventory?',
        save: 'Continue',
        cancel: 'Cancel'
      }, function () {}, function () {
        obj.restoreInventory = true;
      });
    };

    obj.cancel = function (action) {
      if (action == 'close') {
        $uibModalInstance.close(false);
      } else {
        $uibModalInstance.dismiss(action);
      }
    };

    obj.save = function () {
      if (obj.showRestoreInventory) {
        common.setValueRestoreInventory(obj.restoreInventory);
      }

      if (obj.showIssue) {

        if (obj.issue) {
          common.setValueIssue(obj.issue);
          $uibModalInstance.close(true);
        } else {
          alertify.error('you did not select the type of issue');
        }
      } else {
        $uibModalInstance.close(true);
      }
    };

    init();
  }
})(angular);
//# sourceMappingURL=confirmModalCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('promptModalCtrl', ['alertify', '$uibModalInstance', 'config', promptModalCtrl]);

  function promptModalCtrl(alertify, $uibModalInstance, config) {
    var obj = this;
    obj.data = '';

    function init() {
      obj.msj = config.msj || '';
      obj.saveText = config.save || 'Ok';
      obj.cancelText = config.cancel || 'Cancel';
      obj.hideCancelBtn = config.hideCancel || false;
    }

    obj.cancel = function () {
      $uibModalInstance.close('');
    };

    obj.save = function () {
      $uibModalInstance.close(obj.data);
    };

    init();
  }
})(angular);
//# sourceMappingURL=promptModalCtrl.js.map

'use strict';

(function (angular) {
  angular.module('ibf').controller('landingCtrl', ['$scope', '$state', '$stateParams', 'alertify', 'commonSrv', 'sessionSrv', '$uibModal', landingCtrl]).controller('videoTourCtrl', ['$scope', '$uibModalInstance', videoTourCtrl]);

  function landingCtrl($scope, $state, $stateParams, alertify, commonSrv, sessionSrv, $uibModal) {

    var obj = this,
        common = commonSrv,
        session = sessionSrv;
    obj.isLoading = false;
    obj.facebook = 'https://www.facebook.com/ibuyflowersllc/';
    obj.twitter = 'https://twitter.com/ibuyflowers';
    obj.instagram = 'https://www.instagram.com/ibuyflowers';
    obj.pinterest = 'https://www.pinterest.com/ibuyflowers';

    if ($state.current.name == 'landing.signup') {
      common.setHeaders(common.actual_tokens);
    } else {
      common.setHeaders('xxxxx');
    }

    function init() {

      if ($state.current.name == 'landing.signup') {
        obj.getStates();
        obj.getTimeZones();
        obj.getCountry();
        obj.resaleCertificate = false;
        obj.hour_from = '09:00';
        obj.hour_to = '18:00';
      }
    }

    obj.dayHours = {
      hours: [{ hour: '00:00' }, { hour: '01:00' }, { hour: '02:00' }, { hour: '03:00' }, { hour: '04:00' }, { hour: '05:00' }, { hour: '06:00' }, { hour: '07:00' }, { hour: '08:00' }, { hour: '09:00' }, { hour: '10:00' }, { hour: '11:00' }, { hour: '12:00' }, { hour: '13:00' }, { hour: '14:00' }, { hour: '15:00' }, { hour: '16:00' }, { hour: '17:00' }, { hour: '18:00' }, { hour: '19:00' }, { hour: '20:00' }, { hour: '21:00' }, { hour: '22:00' }, { hour: '23:00' }]
    };

    obj.getStates = function () {

      var query = {
        'domain': common.actual_domain,
        'page': 1,
        'row_model': 'state',
        'size': 1000
      };

      common.method.query(common.urls.find, query).then(function () {

        var res = common.response.post_query.data;
        if (res.results) {

          obj.states = res.results;
          angular.forEach(obj.states, function (element) {
            element.state += ' (' + element.state_iso + ')';
          });
        } else {
          alertify.error(res.error);
        }
      });
    };

    obj.getTimeZones = function () {
      var query = {
        'domain': common.actual_domain,
        'page': 1,
        'row_model': 'time_zone',
        'size': 1000
      };

      common.method.query(common.urls.find, query).then(function () {

        var res = common.response.post_query.data;
        if (res.results) {
          obj.timezones = common.response.post_query.data.results;
          obj.timeZoneMap = common.toMap(obj.timezones, 'timeMap', 'time_zone');
        } else {
          alertify.error(res.error);
        }
      });
    };

    obj.selectTimeZone = function (option) {

      obj.time_zone = obj.timeZoneMap[option.time_zone];
    };

    obj.getCountry = function () {
      var query = {
        'domain': common.actual_domain,
        'page': 1,
        'row_model': 'country',
        'size': 1000
      };

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          obj.countries = res.results;
          angular.forEach(obj.countries, function (element) {
            element.country += ' (' + element.country_iso + ')';
            if (element.country_iso == 'US') {
              obj.country = element;
            }
          });
        } else {
          alertify.error(res.error);
        }
      });
    };

    obj.checkState = function () {

      obj.selectTimeZone(obj.state);
      if (obj.state.state_iso == 'NY') {
        common.confirmModal({
          title: 'Resale Certificate Required',
          msj: 'Do you have a \'Resale Certificate\'?',
          saveText: 'Yes',
          cancelText: 'No'
        }, function () {
          obj.resaleCertificate = true;
        });
      }
    };

    function getRandomManager() {
      var manager = 'sales';
      manager += Math.floor(Math.random() * 3) + 2;
      manager += '@ibuyflowers.com';
      return manager;
    }

    obj.save = function () {
      var msg = '';
      var valid = true;
      obj.isLoading = true;
      $scope.$broadcast('show-errors-check-validity');
      if (obj.customerForm.$invalid) {
        valid = false;
        msg = 'There are invalid fields';
      }

      if (obj.confirmPassword != obj.password) {
        valid = false;
        msg = 'User Passwords must match.';
      }

      if (obj.confirmEmail != obj.email) {
        valid = false;
        msg = 'User Emails must match.';
      }

      if (valid && obj.state.state_iso == 'NY' && !obj.resaleCertificate) {
        msg = 'Dear user, We are very sorry, but we cannot accept clients without a resale certificate. Once you have this certificate, please feel fee to subscribe yourself again.';
        valid = false;
      }

      if (valid) {
        var customer = {
          company_name: obj.name,
          street: obj.street,
          state: obj.state._KEY,
          zipcode: obj.zip_code,
          city: obj.city,
          country: obj.country._KEY,
          office_phone: obj.office_phone,
          office_email: obj.office_email,
          business_hours: obj.hour_from + '-' + obj.hour_to,
          time_zone: obj.time_zone._KEY,
          margin: common.margin_actual,
          active: true,
          acc_manager: $stateParams.sales ? $stateParams.sales + '@ibuyflowers.com' : getRandomManager()
        };

        if (obj.state != null && obj.state.state_iso == 'NY') {
          customer.tax_id = obj.tax;
        }

        var user_info = {
          first_name: obj.firstName,
          last_name: obj.lastName,
          role: 'FLORIST',
          customer: null,
          cellphone: obj.cellPhone,
          user_email: obj.email,
          is_admin: true,
          active: true
        };

        obj.customer_query = {
          'domain': common.actual_domain,
          'rows': [customer],
          'row_model': 'customer'
        };

        obj.user_query = {
          'domain': common.actual_domain,
          'rows': [user_info],
          'row_model': 'user'
        };

        common.method.query(common.urls.row, obj.customer_query).then(function () {

          try {
            if (common.response.post_query.data.success) {
              var response = common.response.post_query.data.keys;
              var key = response[0];
              obj.user_query.rows[0].customer = key;
              obj.registerUser(obj.user_query.rows[0]);
              obj.createCustomerFolder(key);
            }
          } catch (e) {
            obj.isLoading = false;
          }
          obj.isLoading = false;
        });
      } else {
        obj.isLoading = false;
        alertify.error(msg);
      }
    };

    obj.createCustomerFolder = function (customer_key) {
      common.method.post(common.urls.addFolder, {
        parent_key: common.florist_folder_key,
        name: customer_key
      }).then(function () {

        var response = common.response.post.data;
        if (response.success) {
          console.log('Customer Folder Created');
        } else {
          alertify.error(response.error);
        }
      });
    };

    obj.registerUser = function (user) {

      var valid = true,
          msg = '';

      var aux_login_user = user.user_email.replace('@', '.');
      var username = aux_login_user.substr(0, aux_login_user.lastIndexOf('.'));

      var reg = {
        email: user.user_email,
        password: obj.password,
        name: user.first_name + ' ' + user.last_name,
        login: username,
        domain: common.actual_domain
      };

      common.method.get(common.urls.register, reg).then(function () {
        obj.isLoading = false;

        var response = common.response.get.data;
        if (response.success) {
          obj.user_query.rows[0].user_id = response.user.id;
          obj.user_info = {
            user: response.user.id,
            customer: user.customer
          };

          obj.setCustomerAdmin(obj.user_info);
          obj.saveUser(obj.user_query);
          var name = user.first_name + ' ' + user.last_name;

          obj.sendSignupMail(name, obj.password, obj.email);
        } else {

          if (response.error === 'Login and/or email already in use.') {
            alertify.alert('This account already exists. If you forgot your password go to forgot my password , or sign up with a new account');
          } else {
            alertify.error('Cannot register user');
          }
          var delete_customer = {
            'domain': common.actual_domain,
            'row_model': 'customer',
            'where': {
              'keys': [user.customer]
            }
          };

          common.method.query(common.urls.delete, delete_customer);
        }
      });
    };

    obj.setCustomerAdmin = function (admin) {
      var query = {
        'domain': common.actual_domain,
        'rows': [{
          'admin': admin.user,
          '_KEY': admin.customer
        }],
        'row_model': 'customer'
      };

      common.method.query(common.urls.update, query);
    };

    obj.saveUser = function (query) {
      return common.method.query(common.urls.row, query).then(function () {
        var response = common.response.post_query.data;
        if (response.success) {
          obj.setAdminPermissions(response.keys[0]);
        }
        alertify.success('Customer Created.');
        $state.go('landing.registered');
      });
    };

    obj.setAdminPermissions = function (key) {
      obj.perm = {
        user: key,
        ibuyflowers: true,
        auto_buy: true,
        standing_orders: true,
        purchase_orders: true,
        claims: true,
        accounting: true
      };

      var query = {
        'domain': common.actual_domain,
        'rows': [obj.perm],
        'row_model': 'customer_user_config'
      };

      common.method.query(common.urls.row, query).then(function () {
        var response = common.response.post_query.data;
      });
    };

    obj.sendMail = function () {
      $scope.$broadcast('show-errors-check-validity');
      if (obj.emailForm.$invalid) {
        obj.isLoading = false;
        alertify.error('All fields are required.');
        return;
      }

      var mail = {
        'subject': 'Contact iBuyflowers',
        'to': 'info@ibuyflowers.com',
        'bcc': 'info@ibuyflowers.com',
        'domain': common.actual_domain,
        'from': 'info@ibuyflowers.com',
        'html': '<html><body>' + 'Name    : ' + obj.contact.name + '<br/>' + 'Email   : ' + obj.contact.email + '<br/>' + 'Message : ' + obj.contact.message + '<br/>' + '</body></html>'
      };

      common.method.send_mail(mail).then(function (res) {
        if (res.success) {
          common.confirmModal({
            title: 'Thanks for contact us.',
            msj: 'We have received your message and will be in contact very soon.',
            saveText: 'OK',
            hideCancel: true
          }, function () {});
        }
      });
    };

    obj.sendSignupMail = function (name, pass, email) {
      var mail = {
        'subject': 'iBuyFlowers login credentials',
        //"to": email,
        'to': email,
        'domain': common.actual_domain,
        'from': 'info@ibuyflowers.com',
        'template_key': common.template_email_sign_up,
        'data': {
          'name': name,
          'email': email,
          'pass': pass
        }
      };

      common.method.send_mail(mail).then(function (res) {
        if (res.success) {
          console.log('Email sent !!!');
        }
      });
    };

    obj.video_tour = function () {
      var modalInstance = $uibModal.open({
        templateUrl: 'views/landing/landing.video_tour.html',
        controller: 'videoTourCtrl',
        controllerAs: 'obj',
        bindToController: true,
        size: 'lg',
        windowClass: 'video_tour',
        resolve: {
          config: function config() {}
        }
      });
      modalInstance.result.then(function (data) {
        obj.loadMasterlists();
      });
    };

    init();
  }

  function videoTourCtrl($scope, $uibModalInstance) {
    var obj = this;
    obj.link = 'https://www.youtube.com/embed/6PQyK22xJeY';
    obj.close = function () {
      $uibModalInstance.dismiss();
    };
  }
})(angular);
//# sourceMappingURL=landingCtrl.js.map
